import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { colors } from '../../styles';

const styles = css`

  padding: 0 0 40px 0;
  margin: 0 0 0 0;
  @media(min-width: 992px) {
    padding: 0 0 70px 0;
  }
  @media(min-width: 1300px) {
    padding: 0 0 90px 0;
  }

  .ContentBanner_wrapper {
    display: flex;
    flex-direction: column;
    padding: 0;
    @media(min-width: 992px) {
      flex-direction: row;
      padding: 20px 0px;
    }
  }
  .PageSection_copy,
  .PageSection_copy p {
    b {
      font-weight: 500;
    }
    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      max-width: 100%;
      align-items: center;
      justify-content: center;
      padding-left: 0;
      li {
        color: ${colors.color4};
        background-color: white;
        padding: 10px 25px;
        margin: 5px;
        border-top: 7px solid ${colors.color1};
        @media(max-width: 768px){
          width: 100%;
        }
        p {
          margin-bottom: 0;
          text-align:center;
        }
      }
    }
  }

`;


function PageSections({ page }) {
  return (
    <div className={styles}>
      <div className="SectionContentBanner_wrapper">
        <div className="container">
          {
            page.map(content => (
              <div key={content._id} className="SectionContentBanner">
                <div className="">
                  {
                    get(content, 'section').map(item => (
                      <div className="ContentBanner_wrapper">
                        <div className={`${get(item, 'image.contentUrl') ? 'col-lg-6' : 'col-lg-12'}`}>
                          <div className="PageSection_copy" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                        </div>
                        {
                          get(item, 'image.contentUrl') &&
                          <div className="col-lg-6">
                            <Image
                              className="w-100"
                              src={get(item, 'image.contentUrl')}
                              alt=""
                              width={1000}
                              height={1000}
                              preserve
                            />
                          </div>
                        }
                      </div>
                    ))
                  }
                </div>
              </div>
           ))
          }
        </div>
      </div>
    </div>
  );
}

PageSections.propTypes = {
  page: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default (PageSections);



// WEBPACK FOOTER //
// ./src/pages/OurArchitect/PageSections.js